import { EVENT_CATEGORIES, EVENT_NAMES, HIT_TYPE } from '../../../beacon/const';

export const pairingErrorBeacon = (action) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.QOS,
  eventName: EVENT_NAMES.PAIRING_ERROR,
  label: action.payload.message,
  value: action.payload.status,
});
